import type { FC } from 'react';

import { AppIconSkeleton, Root } from './styles';

export const MobileAppsColumn: FC = () => (
  <Root customSkeletons={[]}>
    <div>
      <AppIconSkeleton />
      <AppIconSkeleton />
    </div>
  </Root>
);
